import api from '../common/api/networkApi';
import generalApi from '../common/api';

const basePath = '/networks';

export default {
  getList(params = {}) {
    return api.get('/network/v2/working', { params });
  },
  getGeneralList(params = {}) {
    return generalApi.get('/mediaItems/filters', { params });
  },
  create(network) {
    return api.post(basePath, network);
  },
  get(networkId, params = {}) {
    return api.get(`${basePath}/${networkId}`, { params });
  },
  update(networkId, network) {
    return api.put(`${basePath}/${networkId}`, network);
  }
};



// WEBPACK FOOTER //
// ./src/services/networkService.js